import ConfigurableFlexItem from './_configurable-flex-item.js'

export default {
  name: 'FlexItemBase',
  values: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
    $mixin: [
      {
        configSet: ConfigurableFlexItem,
      },
    ],
  },
  meta: {
    extendable: false,
  },
}
